import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';

const UserBenefitsLanding = () => {
  const planesMembresia = [
    {
      nombre: "Explorador",
      precio: "$20,000 COP/mes",
      icon: "Compass",
      color: "blue",
      beneficios: [
        "Acceso a la plataforma",
        "Escaneo QR",
        "500 Notificaciones",
        "Historial de descuentos",
        "Soporte por Email"
      ],
      destacado: false,
      discountLimit: "Ideal para empezar",
      notificationQuota: "15 descuentos/mes"
    },
    {
      nombre: "Emprendedor",
      precio: "$50,000 COP/mes",
      icon: "Rocket",
      color: "purple",
      beneficios: [
        "Acceso a la plataforma",
        "Escaneo QR",
        "2000 Notificaciones",
        "Historial de descuentos",
        "Programa Bizznet Rewards",
        "Soporte prioritario"
      ],
      destacado: true,
      discountLimit: "Para Usuarios Activos",
      notificationQuota: "50 descuentos/mes"
    },
    {
      nombre: "Elite",
      precio: "$70,000 COP/mes",
      icon: "Crown",
      color: "yellow",
      beneficios: [
        "Acceso a la plataforma",
        "Notificaciones ilimitadas",
        "Escaneo QR",
        "Programa Bizznet Rewards",
        "Historial de descuentos",
        "Soporte 24/7 dedicado"
      ],
      destacado: false,
      discountLimit: "Experiencia Premium",
      notificationQuota: "descuentos Ilimitados"
    }
  ];

  const beneficiosClave = [
    {
      icon: "QrCode",
      title: "Escaneo QR Instantáneo",
      description: "Escanea el código QR de cualquier negocio registrado y accede inmediatamente a descuentos exclusivos sin necesidad de cupones físicos"
    },
    {
      icon: "Search",
      title: "Directorio Empresarial Completo",
      description: "Explora miles de negocios colombianos registrados organizados por categoría, ubicación y tipo de descuento disponible"
    },
    {
      icon: "BadgePercent",
      title: "Descuentos Exclusivos Verificados",
      description: "Accede a ofertas reales y verificadas de negocios locales: restaurantes, tiendas, servicios, entretenimiento y más"
    },
    {
      icon: "TrendingUp",
      title: "Bizznet Rewards - Programa de Afiliados",
      description: "Invita amigos y negocios a BIZZNET y gana comisiones recurrentes por cada registro exitoso (disponible en planes Emprendedor y Elite)"
    },
    {
      icon: "Bell",
      title: "Notificaciones Inteligentes",
      description: "Recibe alertas personalizadas sobre promociones activas en negocios cercanos según tus preferencias y ubicación"
    },
    {
      icon: "History",
      title: "Historial de Descuentos",
      description: "Revisa todos los descuentos que has utilizado, tus ahorros totales acumulados y tus negocios favoritos frecuentes"
    },
    {
      icon: "MapPin",
      title: "Mapa Interactivo de Negocios",
      description: "Visualiza en un mapa todos los negocios registrados cerca de ti con descuentos activos disponibles en tiempo real"
    },
    {
      icon: "Star",
      title: "Sistema de Reseñas y Favoritos",
      description: "Califica negocios, deja reseñas de tu experiencia y guarda tus lugares favoritos para acceso rápido"
    }
  ];

  const comoFunciona = [
    {
      numero: "1",
      titulo: "Regístrate y Elige tu Plan",
      descripcion: "Crea tu cuenta en BIZZNET en menos de 2 minutos y selecciona el plan de membresía que mejor se adapte a tus necesidades",
      icon: "UserPlus"
    },
    {
      numero: "2",
      titulo: "Explora el Directorio",
      descripcion: "Navega por el catálogo completo de negocios registrados filtrados por ubicación, categoría y tipo de descuento",
      icon: "Search"
    },
    {
      numero: "3",
      titulo: "Escanea el Código QR",
      descripcion: "Visita el negocio físicamente y escanea su código QR único desde la app para activar el descuento exclusivo",
      icon: "QrCode"
    },
    {
      numero: "4",
      titulo: "Obtén tu Descuento Inmediato",
      descripcion: "Muestra la confirmación de escaneo al negocio y disfruta de tu descuento verificado aplicado directamente en tu compra",
      icon: "BadgeCheck"
    },
    {
      numero: "5",
      titulo: "Comparte y Gana (Opcional)",
      descripcion: "Si tienes plan Emprendedor o Elite, invita a otros usuarios y negocios para ganar comisiones recurrentes con Bizznet Rewards",
      icon: "Users"
    }
  ];

  const testimoniosUsuarios = [
    {
      nombre: "Carolina Méndez",
      ciudad: "Pasto",
      plan: "Emprendedor",
      comentario: "Llevo 6 meses usando BIZZNET y he ahorrado más de $300,000 pesos en restaurantes y tiendas. Además, con el programa de afiliados gano $120,000 mensuales extra",
      ahorro: "$420,000 COP",
      calificacion: 5
    },
    {
      nombre: "Diego Santamaría",
      ciudad: "Bogotá",
      plan: "Elite",
      comentario: "El plan Elite vale cada peso. Los descuentos VIP y el programa de puntos me han permitido ahorrar casi $1,000,000 en mi primer año",
      ahorro: "$980,000 COP",
      calificacion: 5
    },
    {
      nombre: "Valentina Rojas",
      ciudad: "Medellín",
      plan: "Explorador",
      comentario: "Perfecto para estudiantes como yo. Solo con el plan básico he descubierto descuentos increíbles en lugares que frecuento y he ahorrado $150,000",
      ahorro: "$150,000 COP",
      calificacion: 5
    }
  ];

  const estadisticas = [
    { numero: "50,000+", label: "Usuarios Activos", icon: "Users" },
    { numero: "$15M+", label: "Ahorrados por Usuarios", icon: "PiggyBank" },
    { numero: "15,000+", label: "Negocios Disponibles", icon: "Store" },
    { numero: "98%", label: "Satisfacción de Usuarios", icon: "ThumbsUp" }
  ];

  const categoriasPopulares = [
    { nombre: "Restaurantes", icon: "UtensilsCrossed", descuentos: "10-40%" },
    { nombre: "Moda y Accesorios", icon: "Shirt", descuentos: "15-50%" },
    { nombre: "Salud y Belleza", icon: "Sparkles", descuentos: "20-35%" },
    { nombre: "Entretenimiento", icon: "Gamepad2", descuentos: "10-30%" },
    { nombre: "Deportes y Fitness", icon: "Dumbbell", descuentos: "15-40%" },
    { nombre: "Tecnología", icon: "Laptop", descuentos: "5-25%" },
    { nombre: "Servicios del Hogar", icon: "Home", descuentos: "10-30%" },
    { nombre: "Educación", icon: "GraduationCap", descuentos: "20-45%" }
  ];

  const bizznetRewards = {
    nivelUno: {
      comision: "20%",
      descripcion: "Gana el 20% de comisión por cada usuario que invites directamente y se registre con plan Emprendedor o Elite",
      ejemplo: "Si invitas 50 usuarios con plan Emprendedor ($50.000), ganas $500.000 mensuales y lo mejor es que este valor se puede volver recurrentes"
    },
    nivelDos: {
      comision: "10%",
      descripcion: "Gana el 10% adicional por cada usuario que tus referidos inviten (segundo nivel de red)",
      ejemplo: "Si tus 50 invitados invitan a 10 usuarios mas cada uno con el plan Emprendedor ($50.000), ganas $2.500.000 mensuales y lo mejor es que este valor se puede volver recurrente"
    }
  };

  const preguntas = [
    {
      pregunta: "¿Cómo funcionan los descuentos con código QR?",
      respuesta: "Cada negocio tiene un código QR único. Al escanearlo con tu app BIZZNET, se activa automáticamente el descuento asociado y se registra en tu historial. Solo debes mostrar la confirmación al negocio para aplicar el descuento."
    },
    {
      pregunta: "¿Puedo cambiar de plan en cualquier momento?",
      respuesta: "Sí, puedes actualizar o cambiar tu plan de membresía en cualquier momento desde tu panel de usuario. Los cambios se aplican en el siguiente ciclo de facturación."
    },
    {
      pregunta: "¿Cómo funciona Bizznet Rewards?",
      respuesta: "Bizznet Rewards es nuestro programa de afiliados disponible para planes Emprendedor y Elite. Compartes tu código de referido único, ganas comisiones por cada registro exitoso en dos niveles: 20% nivel 1 (directos) y 10% nivel 2 (referidos de tus referidos)."
    },
    {
      pregunta: "¿Los descuentos tienen límite de uso?",
      respuesta: "Depende del plan: Explorador y Emprendedor tienen límites mensuales de escaneos QR. El plan Elite tiene escaneos ilimitados. Cada negocio puede tener términos específicos para sus descuentos."
    }
  ];

  return (
    <>
      <Helmet>
        <title>BIZZNET Usuarios - Descuentos Exclusivos y Ahorro Garantizado</title>
        <meta name="description" content="Únete a BIZZNET y accede a descuentos exclusivos en miles de negocios colombianos. Escanea códigos QR, explora el directorio empresarial y gana dinero con Bizznet Rewards." />
      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-purple-900 via-purple-800 to-purple-700 py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <Link to="/" className="text-white/90 hover:text-white transition-colors drop-shadow-md">
                <Icon name="ArrowLeft" size={24} />
              </Link>
              <div className="flex items-center gap-3">
                <Icon name="Users" size={40} className="text-white drop-shadow-lg" />
                <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg">BIZZNET Usuarios</h1>
              </div>
            </div>
            <p className="text-xl md:text-2xl font-medium max-w-3xl text-white/95 drop-shadow-md mb-8">
              Descuentos exclusivos en miles de negocios colombianos + Gana dinero invitando amigos con Bizznet Rewards
            </p>
            <div className="flex justify-center">
              <Link
                to="/user-registration"
                className="bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-colors inline-flex items-center justify-center gap-2 shadow-lg"
              >
                <Icon name="Zap" size={20} />
                Registrarme como Usuario
              </Link>
            </div>
          </div>
        </section>

        {/* Estadísticas */}
        <section className="py-12 px-6 bg-card border-b border-border">
          <div className="max-w-7xl mx-auto">
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {estadisticas?.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name={stat?.icon} size={32} className="text-primary" />
                  </div>
                  <div className="text-4xl font-bold text-primary mb-2">{stat?.numero}</div>
                  <p className="text-sm text-muted-foreground">{stat?.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Planes de Membresía */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Planes de Membresía BIZZNET
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Elige el plan que mejor se adapte a tu estilo de vida y empieza a ahorrar desde el primer día
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {planesMembresia?.map((plan, index) => (
                <div 
                  key={index}
                  className={`bg-card border-2 rounded-2xl p-8 hover:shadow-2xl transition-all flex flex-col ${
                    plan?.destacado 
                      ? 'border-primary shadow-lg transform scale-105' 
                      : 'border-border'
                  }`}
                >
                  {plan?.destacado && (
                    <div className="bg-primary text-primary-foreground text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
                      MÁS POPULAR
                    </div>
                  )}
                  <div className={`bg-${plan?.color}-500/10 w-16 h-16 rounded-xl flex items-center justify-center mb-4`}>
                    <Icon name={plan?.icon} size={32} className={`text-${plan?.color}-500`} />
                  </div>
                  <h3 className="text-2xl font-bold text-foreground mb-2">{plan?.nombre}</h3>
                  <div className="text-3xl font-bold text-primary mb-4">{plan?.precio}</div>
                  
                  <div className="mb-6 space-y-2">
                    <div className="bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg p-3">
                      <p className="text-sm font-bold text-foreground">{plan?.discountLimit}</p>
                    </div>
                    <div className="bg-gradient-to-r from-gray-100 to-gray-50 rounded-lg p-3">
                      <p className="text-sm font-bold text-gray-800">{plan?.notificationQuota}</p>
                    </div>
                  </div>

                  <ul className="space-y-3 mb-8 flex-grow">
                    {plan?.beneficios?.map((beneficio, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <Icon name="CheckCircle2" size={18} className="text-green-500 flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-muted-foreground">{beneficio}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/user-registration"
                    className={`block text-center py-3 rounded-xl font-semibold transition-colors mt-auto ${
                      plan?.destacado
                        ? 'bg-primary text-primary-foreground hover:bg-primary/90'
                        : 'bg-muted text-foreground hover:bg-muted/80'
                    }`}
                  >
                    Elegir Plan {plan?.nombre}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Beneficios Clave */}
        <section className="py-16 px-6 bg-card">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                ¿Qué Obtienes al Registrarte en BIZZNET?
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Accede a descuentos exclusivos, ahorra dinero en tus compras diarias y gana comisiones con Bizznet Rewards
              </p>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {beneficiosClave?.map((beneficio, index) => (
                <div 
                  key={index}
                  className="bg-background border border-border rounded-xl p-6 hover:shadow-lg transition-shadow"
                >
                  <div className="bg-primary/10 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                    <Icon name={beneficio?.icon} size={28} className="text-primary" />
                  </div>
                  <h4 className="text-lg font-bold text-foreground mb-3">{beneficio?.title}</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {beneficio?.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Cómo Funciona */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Cómo Empezar a Ahorrar en 5 Pasos
              </h2>
              <p className="text-lg text-muted-foreground">
                Del registro a tu primer descuento en minutos. Proceso 100% digital y sin complicaciones
              </p>
            </div>
            <div className="space-y-6">
              {comoFunciona?.map((paso, index) => (
                <div 
                  key={index}
                  className="bg-card border border-border rounded-xl p-6 flex items-start gap-6 hover:shadow-lg transition-shadow"
                >
                  <div className="bg-primary text-primary-foreground w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0 text-2xl font-bold">
                    {paso?.numero}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <Icon name={paso?.icon} size={28} className="text-primary" />
                      <h3 className="text-xl font-bold text-foreground">{paso?.titulo}</h3>
                    </div>
                    <p className="text-muted-foreground leading-relaxed">{paso?.descripcion}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Demostración QR */}
        <section className="py-16 px-6 bg-card">
          <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <Icon name="QrCode" size={36} className="text-primary" />
                  <h2 className="text-3xl font-bold text-foreground">Escaneo QR Instantáneo</h2>
                </div>
                <p className="text-lg text-muted-foreground mb-6">
                  Olvídate de cupones físicos, códigos complicados o membresías en papel. Con BIZZNET, solo necesitas tu celular
                </p>
                <ul className="space-y-4">
                  {[
                    "Visita el negocio físicamente",
                    "Abre la app BIZZNET y toca el botón de escanear",
                    "Apunta tu cámara al código QR del negocio",
                    "El descuento se activa automáticamente",
                    "Muestra la confirmación al cajero",
                    "Disfruta tu descuento inmediato verificado"
                  ]?.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <Icon name="CheckCircle2" size={20} className="text-green-500 flex-shrink-0 mt-1" />
                      <span className="text-muted-foreground">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-background border-2 border-border rounded-2xl p-8">
                <div className="bg-primary/5 rounded-xl p-6 mb-6 text-center">
                  <div className="bg-white p-6 rounded-lg inline-block mb-4">
                    <Icon name="QrCode" size={120} className="text-foreground" />
                  </div>
                  <h3 className="text-xl font-bold text-foreground mb-2">Código QR del Negocio</h3>
                  <p className="text-sm text-muted-foreground">Escanea para activar el descuento</p>
                </div>
                <div className="bg-green-500/10 border border-green-500 rounded-xl p-6 text-center">
                  <Icon name="CheckCircle2" size={48} className="text-green-500 mx-auto mb-3" />
                  <p className="text-lg font-bold text-green-500 mb-1">¡Descuento Activado!</p>
                  <p className="text-sm text-muted-foreground">25% de descuento aplicado en tu compra</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Categorías Populares */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Descuentos en Todas las Categorías
              </h2>
              <p className="text-lg text-muted-foreground">
                Ahorra en restaurantes, moda, entretenimiento, servicios y mucho más
              </p>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {categoriasPopulares?.map((categoria, idx) => (
                <div key={idx} className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                  <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name={categoria?.icon} size={32} className="text-primary" />
                  </div>
                  <h3 className="text-lg font-bold text-foreground mb-2">{categoria?.nombre}</h3>
                  <p className="text-sm text-muted-foreground">Descuentos del</p>
                  <p className="text-xl font-bold text-primary">{categoria?.descuentos}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bizznet Rewards */}
        <section className="py-16 px-6 bg-card">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <div className="flex items-center justify-center gap-3 mb-4">
                <Icon name="TrendingUp" size={36} className="text-primary" />
                <h2 className="text-3xl md:text-4xl font-bold text-foreground">
                  Bizznet Rewards - Programa de Afiliados
                </h2>
              </div>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Gana dinero recurrente invitando amigos y negocios a BIZZNET (Disponible en planes Emprendedor y Elite)
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-background border-2 border-primary rounded-xl p-8">
                <div className="bg-primary/10 w-16 h-16 rounded-xl flex items-center justify-center mb-4">
                  <Icon name="Users" size={32} className="text-primary" />
                </div>
                <h3 className="text-2xl font-bold text-foreground mb-4">Nivel 1 - Referidos Directos</h3>
                <div className="text-4xl font-bold text-primary mb-4">{bizznetRewards?.nivelUno?.comision} Comisión</div>
                <p className="text-muted-foreground mb-4">{bizznetRewards?.nivelUno?.descripcion}</p>
                <div className="bg-primary/5 p-4 rounded-lg">
                  <p className="text-sm text-foreground"><strong>Ejemplo:</strong> {bizznetRewards?.nivelUno?.ejemplo}</p>
                </div>
              </div>
              <div className="bg-background border-2 border-purple-500 rounded-xl p-8">
                <div className="bg-purple-500/10 w-16 h-16 rounded-xl flex items-center justify-center mb-4">
                  <Icon name="Network" size={32} className="text-purple-500" />
                </div>
                <h3 className="text-2xl font-bold text-foreground mb-4">Nivel 2 - Red de Segundo Nivel</h3>
                <div className="text-4xl font-bold text-purple-500 mb-4">{bizznetRewards?.nivelDos?.comision} Comisión</div>
                <p className="text-muted-foreground mb-4">{bizznetRewards?.nivelDos?.descripcion}</p>
                <div className="bg-purple-500/5 p-4 rounded-lg">
                  <p className="text-sm text-foreground"><strong>Ejemplo:</strong> {bizznetRewards?.nivelDos?.ejemplo}</p>
                </div>
              </div>
            </div>
            <div className="bg-background border border-border rounded-xl p-8 text-center">
              <h3 className="text-2xl font-bold text-foreground mb-4">Potencial de Ganancias Mensuales</h3>
              <div className="grid sm:grid-cols-3 gap-6">
                <div>
                  <div className="text-3xl font-bold text-primary mb-2">$100,000</div>
                  <p className="text-sm text-muted-foreground">Con 10 referidos directos + red</p>
                </div>
                <div>
                  <div className="text-3xl font-bold text-primary mb-2">$200,000</div>
                  <p className="text-sm text-muted-foreground">Con 20 referidos directos + red</p>
                </div>
                <div>
                  <div className="text-3xl font-bold text-primary mb-2">$400,000+</div>
                  <p className="text-sm text-muted-foreground">Con 40 referidos directos + red</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonios */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Historias Reales de Usuarios BIZZNET
              </h2>
              <p className="text-lg text-muted-foreground">
                Usuarios colombianos que ya están ahorrando y ganando dinero con BIZZNET
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {testimoniosUsuarios?.map((test, index) => (
                <div 
                  key={index}
                  className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow"
                >
                  <div className="flex gap-1 mb-4">
                    {[...Array(test?.calificacion)]?.map((_, i) => (
                      <Icon key={i} name="Star" size={20} className="text-yellow-500 fill-yellow-500" />
                    ))}
                  </div>
                  <p className="text-muted-foreground mb-4 italic leading-relaxed">
                    "{test?.comentario}"
                  </p>
                  <div className="border-t border-border pt-4">
                    <p className="font-bold text-foreground">{test?.nombre}</p>
                    <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1">
                      <Icon name="MapPin" size={14} />
                      {test?.ciudad}
                    </p>
                    <div className="flex items-center gap-2 mt-2">
                      <span className="bg-primary/10 text-primary text-xs font-semibold px-2 py-1 rounded">
                        Plan {test?.plan}
                      </span>
                      <span className="text-green-500 font-bold text-sm">
                        Ahorro: {test?.ahorro}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Preguntas Frecuentes */}
        <section className="py-16 px-6 bg-card">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Preguntas Frecuentes
              </h2>
            </div>
            <div className="space-y-4">
              {preguntas?.map((item, index) => (
                <div key={index} className="bg-background border border-border rounded-xl p-6">
                  <h3 className="text-lg font-bold text-foreground mb-3 flex items-start gap-2">
                    <Icon name="HelpCircle" size={20} className="text-primary flex-shrink-0 mt-1" />
                    {item?.pregunta}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed pl-7">{item?.respuesta}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 px-6 bg-gradient-to-br from-purple-900 via-purple-800 to-purple-700">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white drop-shadow-lg">
              ¿Listo para Empezar a Ahorrar?
            </h2>
            <p className="text-lg mb-8 text-white/95 drop-shadow-md">
              Únete a los 50,000+ usuarios que ya están disfrutando de descuentos exclusivos en Colombia
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Link
                to="/user-registration"
                className="bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-colors inline-flex items-center justify-center gap-2 shadow-lg"
              >
                <Icon name="Zap" size={20} />
                Registrarme AHORA
              </Link>
              <Link
                to="/faq"
                className="bg-white/10 text-white border-2 border-white/30 px-8 py-4 rounded-xl font-semibold hover:bg-white/20 transition-colors inline-flex items-center justify-center gap-2 backdrop-blur-sm"
              >
                <Icon name="HelpCircle" size={20} />
                Más Información
              </Link>
            </div>
            <div className="flex items-center justify-center gap-8 text-white/90">
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} />
                <span className="text-sm">Registro Rápido</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} />
                <span className="text-sm">Descuentos Inmediatos</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} />
                <span className="text-sm">Gana Dinero Extra</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default UserBenefitsLanding;